export enum HistoryType {
  Status = 1,
  Action,
}